import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import { DetailsBooking } from 'types';
import { ContentHeading } from 'components/Typography';
import BottomTotal from 'components/BottomTotal';
import LineItem from 'components/LineItem';
import PaymentsCard from 'components/PaymentsCard';

interface Props {
  booking: DetailsBooking;
}

const CancellationSummary: React.FC<Props> = ({ booking }) => {
  if (!booking.cancellationRefund) {
    return null;
  }

  return (
    <>
      <ContentHeading>Cancellation summary</ContentHeading>
      <PaymentsCard>
        <LineItem title="Total paid to date" totals={booking.paidBeforeCancellation.totals} />
        {!isEmpty(booking.cancellationRefund.penalty) && <LineItem title="Penalty & charges" totals={booking.cancellationRefund.penalty} />}
        <BottomTotal title="Total refund" totals={booking.cancellationRefund.totals} />
      </PaymentsCard>
    </>
  );
};

export default CancellationSummary;
